import type { MatchModelBase } from '@nf/types/odds';
import { PeriodScoresFactory } from './period-scores.factory';

/**
 * Get period scores for a match, e.g., ['11-22', '30-52']
 * @param match - The match to get period scores for
 * @returns The period scores for the match
 */
const getPeriodScores = (match: MatchModelBase): Array<string> => {
	const periodScoresStrategy = PeriodScoresFactory.createPeriodScoresStrategy(match);
	return periodScoresStrategy.createPeriodScores();
}

export const periodScoresService = {
	getPeriodScores
};